/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Study_Medical_Technology22Inputs */

const en__field_enum_study_medical_technology22 = /** @type {(inputs: _Field_Enum_Study_Medical_Technology22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medical Technology`)
};

const de__field_enum_study_medical_technology22 = /** @type {(inputs: _Field_Enum_Study_Medical_Technology22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medizintechnik`)
};

/**
* | output |
* | --- |
* | "Medical Technology" |
*
* @param {_Field_Enum_Study_Medical_Technology22Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_study_medical_technology22 = /** @type {((inputs?: _Field_Enum_Study_Medical_Technology22Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Study_Medical_Technology22Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_study_medical_technology22(inputs)
	return de__field_enum_study_medical_technology22(inputs)
});
export { _field_enum_study_medical_technology22 as "_field_enum_STUDY_MEDICAL_TECHNOLOGY" }